// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { FieldType } from "Core/Utils/Utils";

// Custom
import { BlobImageModel } from "Custom/Models/BlobImageModel";
import { ApiStatus } from "Custom/Models/Enums/ApiStatus";
import { AppUrls } from "Custom/Globals";

export class PrivateImageViewModel extends ViewModelBase<BlobImageModel> {
    constructor(propertyId?: string) {
        super(new BlobImageModel());
        this.setDecorators(BlobImageModel);
    }

    @observable
    public apiStatus: ApiStatus = ApiStatus.loading;

    @computed
    public get ApiStatus(): ApiStatus {
        return this.apiStatus;
    }

    @action
    public setApiStatus(apiStatus: ApiStatus) {
        this.apiStatus = apiStatus;
    }

    public loadImageByURL = async (url: string) => {
        try {
            const encodedUrl = encodeURIComponent(url);
            const apiResult = await this.Get<string>(AppUrls.Server.Api.Image.GetBlob + "/?url=" + encodedUrl);

            return apiResult;
        } catch (exception) {
            console.error("Error in loadImageByURL:", exception);
            this.setApiStatus(ApiStatus.error);
            throw exception;
        }
    };

    // #region Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    // #endregion Boilerplate
}
